import $ from "jquery";

const blogBanner = {
    variable:{
        url: window.location.href,
        category:null,
        blogTitleComponent: $('.blog-banner__heading'),
    },
    methods : {
        handleTitleFont: function() {
            const blogTitle = blogBanner.variable.blogTitleComponent;

            const titleColor = blogTitle.data('title-color');
            const desktopFont = blogTitle.data('desktop-font');
            const tabletFont = blogTitle.data('tablet-font');
            const mobileFont = blogTitle.data('mobile-font');

            const width = window.innerWidth;
            let fontSize = desktopFont;

            if (width <= 576) {
                fontSize = mobileFont;
            } else if (width <= 992) {
                fontSize = tabletFont;
            }

            blogTitle.css('font-size', `${fontSize}px`);
            blogTitle.css('color', `${titleColor}`);
        },
        dataLayerObj : function(el, btnText){
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : btnText,
                'pageSection' : el ? el : "",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? blogBanner.variable.url.includes("blog") ? "Blogs" : blogBanner.variable.url.substring(blogBanner.variable.url.indexOf(".com/"), blogBanner.variable.url.lastIndexOf('/')  === ".com") && !blogBanner.variable.url.substring(blogBanner.variable.url.indexOf(".com/"), blogBanner.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                'bannerType' : ""

            };
            return obj;
        }
    }
};

$(() => {
    blogBanner.methods.handleTitleFont();
    $('.blog_banner--cta .chli_btn--tertiary a').on('click', function(e){

    if(document.querySelector('#pageType') !=null){
        blogBanner.variable.category=document.querySelector('#pageType').value;
        }

        let text = e.currentTarget.innerText.replace(/\n/g, '').trim();
        let section = $(this).closest('.blog-banner__text-area');
        let titleText = section.find('.blog-banner__heading').text().trim();
        let href = $(this).attr('href');
        let flag=blogBanner.variable.category!=null && (blogBanner.variable.category=='Product' || blogBanner.variable.category=='Category Page') ? true : false;
        var obj = blogBanner.methods.dataLayerObj(titleText, text);
        if(!href.includes('.pdf')){
          createDataLayer('buttonClick',obj);
          }
          else if(href.includes('.pdf') && flag){
            createDataLayer('Download_Product',obj);
          }
          else{
          createDataLayer("Download_NonProduct", obj);
          }
    });
    $('.blog_banner--cta .chli_btn--primary a').on('click', function(e){
    if(document.querySelector('#pageType') !=null){
            blogBanner.variable.category=document.querySelector('#pageType').value;
            }
        let text = e.currentTarget.innerText.replace(/\n/g, '').trim();
        let section = $(this).closest('.blog-banner__text-area');
        let titleText = section.find('.blog-banner__heading').text().trim();
        let href = $(this).attr('href');

        let flag=blogBanner.variable.category!=null && (blogBanner.variable.category=='Product' || blogBanner.variable.category=='Category Page') ? true : false;
        var obj = blogBanner.methods.dataLayerObj(titleText, text);
        if(!href.includes('.pdf')){
          createDataLayer('buttonClick',obj);
          }
          else if(href.includes('.pdf') && flag){
            createDataLayer('Download_Product',obj);
          }
          else{
          createDataLayer("Download_NonProduct", obj);
          }
    });
    $('.blog-banner__contact-description .blog-banner-email-svg').on('click', function(e){
            let text = e.currentTarget.innerText.replace(/\n/g, '').trim();
            let section = $(this).closest('.blog-banner__text-area');
            let titleText = section.find('.blog-banner__heading').text().trim();
            var obj = blogBanner.methods.dataLayerObj(titleText, text);
            createDataLayer('buttonClick', obj);
        });

});
